import { Component, ContentChild, ContentChildren, Input, QueryList, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { merge } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AutocompleteContentDirective } from './autocomplete-content.directive';
import { AutocompleteOptionComponent } from './autocomplete-option/autocomplete-option.component';

@Component({
    selector: 'aa-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: [
        './autocomplete.component.scss'
    ],
    exportAs: 'autoComplete',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutocompleteComponent
{
    @ViewChild('root', { static: true }) rootTemplate: TemplateRef<any>;
    @ContentChild(AutocompleteContentDirective, { static: true }) content: AutocompleteContentDirective;
    @ContentChildren(AutocompleteOptionComponent) options: QueryList<AutocompleteOptionComponent>;
    @Input() width: number = 150;

    optionsClick ()
    {
        return this.options.changes
            .pipe(
                switchMap((options: AutocompleteOptionComponent[]) =>
                {
                    const clicks = options.map((option: AutocompleteOptionComponent) =>
                        option.click
                    );

                    return merge(...clicks);
                })
            );
    }
}
